import React, { useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ThemeContext } from '../../context/ThemeContext';
import { API_URL } from '../../utils/api';
import { Title, FormGroup, Label, Input, Button, ErrorMessage, PasswordWrapper, EyeBtn } from '../../components/Auth/SignInContent.styles';

function ResetPassword() {
  const { token }  = useParams();
  const navigate   = useNavigate();
  const { theme }  = useContext(ThemeContext);
  const [password,  setPassword]  = useState('');
  const [password2, setPassword2] = useState('');
  const [showPass,  setShowPass]  = useState(false);
  const [error,     setError]     = useState('');
  const [ok,        setOk]        = useState(false);
  const [loading,   setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('La contraseña debe tener al menos 6 caracteres'); return; }
    if (password !== password2) { setError('Las contraseñas no coinciden'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Error'); return; }
      setOk(true);
      setTimeout(() => navigate('/'), 3000);
    } catch {
      setError('No se pudo conectar con el servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: theme.modalBg || '#1a1a2e', borderRadius: 12, padding: 32, width: '100%', maxWidth: 420, border: '1px solid rgba(255,255,255,0.08)' }}>
        <Title bgColor={theme.modalBg}>Nueva contraseña</Title>
        {ok ? (
          <div style={{ textAlign: 'center', color: '#2ecc71', padding: '16px 0' }}>
            ✅ Contraseña actualizada. Redirigiendo al inicio...
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <FormGroup>
              <Label bgColor={theme.modalBg}>Nueva contraseña</Label>
              <PasswordWrapper>
                <Input type={showPass ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="Mínimo 6 caracteres" accentColor={theme.accent} bgColor={theme.modalBg} />
                <EyeBtn type="button" onClick={() => setShowPass(v => !v)}>{showPass ? '🙈' : '👁️'}</EyeBtn>
              </PasswordWrapper>
            </FormGroup>
            <FormGroup>
              <Label bgColor={theme.modalBg}>Repetir contraseña</Label>
              <PasswordWrapper>
                <Input type={showPass ? 'text' : 'password'} value={password2} onChange={e => setPassword2(e.target.value)}
                  placeholder="Repite la contraseña" accentColor={theme.accent} bgColor={theme.modalBg} />
              </PasswordWrapper>
            </FormGroup>
            {error && <ErrorMessage>{error}</ErrorMessage>}
            <Button type="submit" disabled={loading} accentColor={theme.accent}>
              {loading ? 'Guardando...' : 'Guardar contraseña'}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
